/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { isEmpty } from '@ember/utils';
import PaymentMethod from '@linc-technologies/linced-common/enums/payment-method';
import TransactionType from '@linc-technologies/linced-common/enums/transaction-type';
import ENV from '../../../../config/environment';
import moment from 'moment';

export default class AccountController extends Controller {
  @service
  fetch;

  @service
  features;

  @service
  finance;

  @service
  paperToaster;

  TransactionType = TransactionType;

  @tracked
  refundAmount = null;

  @action
  setRefundAmount(value) {
    this.refundAmount = value;
  }

  @tracked
  refundComment = '';

  @action
  setRefundComment(value) {
    this.refundComment = value;
  }

  @tracked
  refundDate = moment().format('YYYY-MM-DD');

  @action
  setRefundDate(value) {
    this.refundDate = value;
  }

  tillDisabled = false;

  @tracked
  errorMessage;

  @tracked
  refundDialogOpen;

  @tracked
  refundInProgress;

  // displayTransactions is a list of Transactions filtered to those which either:
  // - are not child transactions; or
  // - have a source transaction which is associated with an account other than the one being displayed.
  @computed('model.{transactions.[],account.id}')
  get displayTransactions() {
    return this.model.transactions.filter((transaction) => {
      let sourceTransactionId = transaction.get('sourceTransaction.id');
      let sourceAccountId = transaction.get('sourceTransaction.account.id');
      return !sourceTransactionId || sourceAccountId !== this.model.account.id;
    });
  }

  @action
  toggleRefundDialog() {
    this.errorMessage = '';
    this.toggleProperty('refundDialogOpen');
    if (!this.refundDialogOpen) {
      this.resetRefundForm();
    }
  }

  @action
  refund() {
    this.refundInProgress = true;
    let url = `${ENV.APP.apiHost}/finance/${ENV.APP.apiPath}/accounts/${this.model.account.id}/:refund`;
    let tillId, method;
    if (
      this.features.sapFinance &&
      !this.tillDisabled &&
      !isEmpty(this.get('finance.activeTill'))
    ) {
      tillId = parseInt(this.get('finance.activeTill.id'), 10);
      method = PaymentMethod.CASH;
    }
    let data = {
      comment: this.refundComment,
      date: this.refundDate,
      amount: Math.round(this.refundAmount * 100),
      tillId,
      method,
    };
    let options = {
      data: JSON.stringify(data),
    };
    this.fetch
      .post(url, options)
      .then(() => {
        this.paperToaster.show(`Refund issued successfully.`, {
          duration: 4000,
          position: 'top right',
          toastClass: 'success',
        });
        this.model.account.reload();
        this.model.transactions.update();
        this.refundDialogOpen = false;
        this.resetRefundForm();
      })
      .catch(() => {
        this.paperToaster.show('Error issuing refund!', {
          duration: 4000,
          position: 'top right',
          toastClass: 'warning',
        });
      })
      .then(() => {
        this.refundInProgress = false;
      });
  }

  resetRefundForm() {
    this.refundAmount = null;
    this.refundComment = '';
    this.refundDate = moment().format('YYYY-MM-DD');
  }
}
